module.exports = __webpack_public_path__ + "img/98.6.4cebd4b2.png";